import {isRouteErrorResponse} from 'react-router';

export type ErrorKind = 'generic' | 'network' | 'notFound' | 'server';

export function resolveDevelopmentErrorDetails(
  error: unknown,
): string | undefined {
  if (!import.meta.env.DEV || !(error instanceof Error)) {
    return undefined;
  }

  return error.stack ?? error.message;
}

export function resolveErrorKind(error: unknown): ErrorKind {
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return 'notFound';
    }

    if (error.status >= 500) {
      return 'server';
    }

    return 'generic';
  }

  if (isNetworkError(error)) {
    return 'network';
  }

  return 'generic';
}

function isNetworkError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const normalizedMessage = error.message.toLowerCase();

  return (
    error.name === 'NetworkError'
    || normalizedMessage.includes('network')
    || normalizedMessage.includes('failed to fetch')
    || (error.name === 'TypeError' && normalizedMessage.includes('fetch'))
  );
}
